import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
export var USAGE_API = 'USAGE_API';
export var UsageApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(UsageApi, _AxiosApi);

  var _super = _createSuper(UsageApi);

  function UsageApi(axiosInstance) {
    var _this;

    _classCallCheck(this, UsageApi);

    _this = _super.call(this, '', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(UsageApi, [{
    key: "getWallet",
    value: function () {
      var _getWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var jsonResponse, parsedBodyResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.get('/me/wallet');

              case 3:
                jsonResponse = _context.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context.abrupt("return", Result.ok(parsedBodyResponse.data));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function getWallet() {
        return _getWallet.apply(this, arguments);
      }

      return getWallet;
    }()
  }, {
    key: "getTokenPackages",
    value: function () {
      var _getTokenPackages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var jsonResponse, parsedBodyResponse;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.get('/token-packages');

              case 3:
                jsonResponse = _context2.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(parsedBodyResponse.data.items || []));

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getTokenPackages() {
        return _getTokenPackages.apply(this, arguments);
      }

      return getTokenPackages;
    }()
  }, {
    key: "getPackages",
    value: function () {
      var _getPackages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var _input$limit, jsonResponse, parsedBodyResponse;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.axios.get('/me/packages', {
                  params: _objectSpread({
                    limit: (_input$limit = input === null || input === void 0 ? void 0 : input.limit) !== null && _input$limit !== void 0 ? _input$limit : 10
                  }, input !== null && input !== void 0 && input.nextToken ? {
                    nextToken: input.nextToken
                  } : {})
                });

              case 3:
                jsonResponse = _context3.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context3.abrupt("return", Result.ok(parsedBodyResponse.data));

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function getPackages(_x) {
        return _getPackages.apply(this, arguments);
      }

      return getPackages;
    }()
  }, {
    key: "getTransactions",
    value: function () {
      var _getTransactions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(input) {
        var _input$limit2, jsonResponse, parsedBodyResponse;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.axios.get('/me/wallet/transactions', {
                  params: _objectSpread({
                    limit: (_input$limit2 = input === null || input === void 0 ? void 0 : input.limit) !== null && _input$limit2 !== void 0 ? _input$limit2 : 20
                  }, input !== null && input !== void 0 && input.nextToken ? {
                    nextToken: input.nextToken
                  } : {})
                });

              case 3:
                jsonResponse = _context4.sent;
                parsedBodyResponse = jsonResponse.data;
                return _context4.abrupt("return", Result.ok(parsedBodyResponse.data));

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 8]]);
      }));

      function getTransactions(_x2) {
        return _getTransactions.apply(this, arguments);
      }

      return getTransactions;
    }()
  }]);

  return UsageApi;
}(AxiosApi);